import {SelectInput} from '@geomatico/geocomponents';
import type {SxProps} from '@mui/material';
import {lighten} from '@mui/system/colorManipulator';
import type {FC, ReactNode} from 'react';
import {secondaryColor} from '@/theme/theme';

//TYPES
type StringOption = {
  uuid: string;
  name: string;
};

type Props = {
  selectedOptionId?: string;
  options: Array<StringOption>;
  required?: boolean;
  startAdornment?: ReactNode;
  onChange: (optionId?: string) => void;
};

const Select: FC<Props> = ({selectedOptionId, options, onChange}) => {
  return (
    <SelectInput
      options={options.map((a) => ({id: a.uuid, label: a.name}))}
      onOptionChange={onChange}
      selectedOptionId={selectedOptionId}
      allowEmptyValue={true}
      sx={styles.select}
      menuSx={{
        zIndex: 2000,
      }}
    />
  );
};
export default Select;

const styles: Record<string, SxProps> = {
  select: {
    mb: 1,
    bgcolor: lighten(secondaryColor, 0.95),
    '& .MuiOutlinedInput-root': {
      borderRadius: '0px',
      '&:hover fieldset': {
        borderRadius: '0px',
        borderColor: 'primary.main', // borde hover
      },
      '&.Mui-focused fieldset': {
        borderColor: 'secondary.main', // borde focus
      },
    },
  },
};
